module.exports = __webpack_public_path__ + "img/cs-home-4.31baef0a.png";